// extracted by mini-css-extract-plugin
export default {"sectionProgress":"Confirm_sectionProgress__nTIc6"};